import { render, staticRenderFns } from "./EditFolderOther.vue?vue&type=template&id=05bbd74e&scoped=true"
import script from "./EditFolderOther.vue?vue&type=script&lang=js"
export * from "./EditFolderOther.vue?vue&type=script&lang=js"
import style0 from "./EditFolderOther.vue?vue&type=style&index=0&id=05bbd74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbd74e",
  null
  
)

export default component.exports